import { useTranslation } from '@cobliteam/i18n';
import Tooltip from '@cobliteam/ui/components/Tooltip';

const AlertFooter = () => {
  const { t } = useTranslation('global-search');
  const isMac = /macintosh|mac os x/i.test(navigator.userAgent);

  return (
    <div className='flex h-10 w-full items-center justify-end border-gray-4 border-t px-4'>
      <div className='flex items-center gap-2 text-xs'>
        <Tooltip content={t('alert_footer.shortcut_tooltip')}>
          <kbd className='inline-flex h-5 max-h-full items-center rounded border border-gray-5 bg-gray-2 px-1 font-[inherit] font-medium text-gray-a9 text-xs shadow-sm'>
            {isMac ? '⌘' : 'Ctrl'} + K
          </kbd>
        </Tooltip>
      </div>
    </div>
  );
};

export default AlertFooter;
